import React from 'react';
import { connect } from 'react-redux';
import styled, { css, keyframes } from 'styled-components';
import SignInLink from '@Header/Account/SignInLink';
import PropTypes from 'prop-types';
import { selectProfile } from '@Header/ducks/selectors';
import Profile from './Profile';
import ProfileMobile from './ProfileMobile';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const SignInWrapper = styled.div`
  ${css`animation: ${fadeIn} 250ms ease-out;`}
  opacity: 1;
  line-height: 18px;
`;

const DesktopWrapper = styled.div`
  display: none;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    display: block;
  }
`;

const MobileWrapper = styled.div`
  display: block;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    display: none;
  }
`;

const Account = ({ account, isLoggedIn, purchaseProcessVehiclePrice }) => {
  return (
    <SignInWrapper>
      {isLoggedIn ? (
        <>
          <DesktopWrapper>
            <Profile profile={account} purchaseProcessVehiclePrice={purchaseProcessVehiclePrice} />
          </DesktopWrapper>
          <MobileWrapper>
            <ProfileMobile profile={account} />
          </MobileWrapper>
        </>
      ) : <SignInLink />}
    </SignInWrapper>
  );
};

Account.propTypes = {
  purchaseProcessVehiclePrice: PropTypes.number.isRequired,
  account: PropTypes.shape({}),
  isLoggedIn: PropTypes.bool
};

const mapStateToProps = state => ({
  account: selectProfile(state).userProfile,
  isAwaitingProfileResponse: selectProfile(state).isAwaitingProfileResponse,
  isLoggedIn: selectProfile(state).isLoggedIn,
});

const ConnectedAccount = connect(mapStateToProps)(Account);
// note(oscar): should this have default props? Shouldn't they always be coming from store initial state?
ConnectedAccount.defaultProps = {
  account: null,
  isLoggedIn: false
};

export default ConnectedAccount;
